export default __webpack_public_path__ + "static/media/UKFlag.2a065519.webp";